/**
 * Opens a URL in a new window/tab with security best practices.
 *
 * This function ensures that:
 * - The new window cannot access the parent window (prevents reverse tabnabbing)
 * - The referrer information is not passed to the new page (privacy protection)
 * - Handles cases where popup blocking might occur
 *
 * @param url - The URL to open in the new window
 * @param windowName - Optional name for the window (defaults to '_blank')
 * @returns The opened window object or null if blocked/failed
 */
export function openSecureWindow(
  url: string,
  windowName: string = '_blank',
): Window | null {
  const newWindow = window.open(url, windowName, 'noopener,noreferrer');

  if (newWindow) {
    // Defense in depth: explicitly set opener to null
    // This provides additional security even if the window features aren't fully supported
    newWindow.opener = null;
  }

  return newWindow;
}
